import { StyleSheet } from '@react-pdf/renderer';
import QRCode from 'qrcode';
import { isBlank } from '@witmetrics/utils/strings';
import { formatDate } from '@witmetrics/utils/time';
import type { DateFormat } from '@witmetrics/utils';
import { theme } from '@/utils/theme';
import type { TraceabilityData } from '../types';
import { BLANK_PLACEHOLDER } from './constants';
import './fonts';

export const styles = {
  page: StyleSheet.create({
    wrapper: {
      fontFamily: 'Inter',
      fontWeight: 300,
      color: theme.palette['grey-9'].main,
      backgroundColor: '#FFFFFF',
      paddingVertical: 25,
      paddingHorizontal: 50,
    },
  }),
  header: StyleSheet.create({
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      marginBottom: 14,
    },
    logo: {
      width: '30%',
      height: 'auto',
    },
    title: {
      fontSize: 18,
    },
    subtitle: {
      fontSize: 10,
      fontStyle: 'italic',
      fontWeight: 200,
      maxWidth: 250,
      textAlign: 'center',
    },
  }),
  section: StyleSheet.create({
    wrapper: {
      marginBottom: 20,
      flexGrow: 0,
    },
    title: {
      fontSize: 14,
      fontWeight: 500,
      color: theme.palette['grey-8'].main,
      marginBottom: 8,
    },
  }),
  field: StyleSheet.create({
    wrapper: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: 8,
      paddingHorizontal: 12,
      paddingVertical: 8,
      marginBottom: 4,
      backgroundColor: theme.palette['grey-2'].main,
      borderRadius: 6,
    },
    longWrapper: {
      flexDirection: 'column',
    },
    label: {
      fontSize: 10,
      fontWeight: 600,
      color: theme.palette['grey-8'].main,
    },
    value: {
      fontSize: 10,
      fontWeight: 300,
      maxWidth: 300,
    },
    longValue: {
      maxWidth: '100%',
    },
  }),
  footer: StyleSheet.create({
    wrapper: {
      flexGrow: 1,
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
    },
    qrCode: {
      flexGrow: 0,
      flexShrink: 0,
      width: 'auto',
      maxHeight: 150,
    },
  }),
};

export function displayValue(value: string): string {
  return isBlank(value) ? BLANK_PLACEHOLDER : value;
}

export function displayDate(
  value: string,
  dateFormat: DateFormat | undefined
): string {
  return isBlank(value) ? BLANK_PLACEHOLDER : formatDate(value, dateFormat);
}

export function generateQrCode({
  // orderDescription,
  ...data
}: TraceabilityData) {
  return QRCode.toDataURL(JSON.stringify(data));
}
